<template>
  <div>    
    <v-dialog
      v-model="dialog_import_effects"
      persistent 
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Sincronizar efectos con facturas en Inmatic</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
        
          <v-form v-model="isValidFormImportEffects">
            <div>Fesde desde:</div>
            <app-date-picker
              class="pt-2"
              aucomplete="off"
              v-model="import_effects_min_date"
              :rules="[v => !!v || 'Required']"            
            ></app-date-picker>
            <div>Fesde hasta:</div>
            <app-date-picker
              class="pt-2"
              aucomplete="off"
              v-model="import_effects_max_date"
              :rules="[v => !!v || 'Required']"            
            ></app-date-picker>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="dialog_import_effects=false">Cancelar</v-btn>
          <v-btn 
            :loading="screen_data.loadingImportEffects"
            color="white" 
            :disabled="!isValidFormImportEffects" 
            text 
            class="primary-bckground" 
            @click="importEffects()" 
            >Sincronizar</v-btn>
        </v-card-actions>
      </v-card>
    
    </v-dialog>


    <v-dialog
      v-model="dialog_import_effects_accounting_program"
      persistent 
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Importar efectos del programa contable</span>
          <span class="text-h5 primary--text py-1 ml-2">* Deben ser ambas fechas del mismo año</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
        
          <v-form v-model="isValidFormImportEffectsAccountingProgram">
            <div>Fesde desde:</div>
            <app-date-picker
              class="pt-2"
              aucomplete="off"
              v-model="import_effects_accounting_program_min_date"
              :rules="[v => !!v || 'Required']"            
            ></app-date-picker>
            <div>Fesde hasta:</div>
            <app-date-picker
              class="pt-2"
              aucomplete="off"
              v-model="import_effects_accounting_program_max_date"
              :rules="[v => !!v || 'Required']"            
            ></app-date-picker>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="dialog_import_effects_accounting_program=false">Cancelar</v-btn>
          <v-btn 
            :loading="screen_data.loadingImportEffectsAccountingProgram"
            color="white" 
            :disabled="!isValidFormImportEffectsAccountingProgram" 
            text 
            class="primary-bckground" 
            @click="importEffectsAccountingProgram()" 
            >Importar</v-btn>
        </v-card-actions>
      </v-card>
    
    </v-dialog>

    <v-dialog v-model="screen_data.dialog_upload_excel" max-width="660">
      <v-card class="rounded-lg">
        <v-card-title>
          <span class="text-h6 primary--text">Carga de efectos por fichero excel</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="px-7">
            <v-row>
              <v-col align="center" class="pb-0">
                  <AppIcon src="/icon_table.svg" :size="39" />
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <span class="text-h6 primary--text">Orden Cabecera</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <p class="mb-0">Necesitamos la siguiente estructura</p>
                <p class="font-weight-bold">Fecha / Importe / Cuenta / Concepto / Tipo efecto (C, P) / Num. Factura / Fecha vencimiento / Origen Id (Opcional)</p>
              </v-col>
            </v-row>
    
            <span>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    class="rounded-lg"
                    label="Archivo"
                    v-model="screen_data.file"
                    prepend-icon="mdi-paperclip"
                    color="primary"
                    accept=" .xls, .xlsx, .xlsm, .ods"
                    :clearable="false"
                    :loading="screen_data.loadingUploadEffects"
                    :rules="[v => !!v || 'Archivo requerido']"
                    :error="screen_data.error_upload_file"
                    :error-messages="screen_data.error_message_upload_file"
                    outlined
                  ></v-file-input>
                </v-col>
              </v-row>
            </span>
          </v-container>
        </v-card-text>
      <v-card-actions class="mr-4">
          <v-spacer></v-spacer>
          <app-btn outlined @click="screen_data.dialog_upload_excel = false;">Cancelar</app-btn>
          <app-btn 
            color="primary" 
            @click="uploadExcelEffects()" 
            variant="text"
            :disabled="!screen_data.file"
            :loading="screen_data.loadingUploadEffects"
          >
            Subir
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="screen_data.dialog_configuration" max-width="660">
      <v-card class="rounded-lg">
        <v-card-title>
          <span class="text-h6 primary--text">Configuración de efectos</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="px-7">
            
            <v-radio-group v-model="screen_data.effectsOriginConfig" label="Origen de carga de efectos">
              <v-radio label="Facturas Inmatic" value="inmatic"></v-radio>
              <v-radio label="Programa Contable" value="accounting_program"></v-radio>
              <v-radio label="Excel" value="excel"></v-radio>
            </v-radio-group>

            <v-checkbox
              v-if="screen_data.effectsOriginConfig && screen_data.effectsOriginConfig == 'inmatic'"
              class="ma-0 pt-3"
              v-model="screen_data.automaticEffectsInmaticConfig"              
            >
              <template v-slot:label>
                <span class="text-field-size">Cargar efectos automáticamente de facturas de inmatic</span>
              </template>
            </v-checkbox>
          </v-container>
        </v-card-text>
        <v-card-actions class="mr-4">
          <v-spacer></v-spacer>
          <app-btn outlined @click="screen_data.dialog_configuration = false;">Cancelar</app-btn>
          <app-btn
            color="primary" 
            @click="updateEffectsConfiguration()" 
            variant="text"            
            :loading="screen_data.loadingUploadEffects"
          >
            Guardar
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="screen_data.dialog_create_effect_manual" persistent max-width="600">
      <v-card class="rounded-lg">
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Añadir Efecto</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="screen_data.new_effect">
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-text-field
                label="Concepto"
                type="text"
                :hideDetails="true"
                v-model="screen_data.new_effect.concept"
              >
              </app-text-field>
            </app-col>
          </app-row>
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-text-field
                label="Importe"
                type="number"
                :hideDetails="true"
                v-model="screen_data.new_effect.amount"
              >
              </app-text-field>
            </app-col>
          </app-row>          
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-doc-text-field dense
                  kind="account"                  
                  v-model="screen_data.new_effect.account"
                  label="Cuenta contable"                  
                  :num_digits="currentCompany.num_digits"
                  :hideDetails="true"
                  />                                          
            </app-col>
          </app-row>
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-select
                label="Tipo efecto"
                type="text"
                v-model="screen_data.new_effect.effect_type"
                :items="effects_type"
                :hideDetails="true"
              >
              </app-select>
            </app-col>
          </app-row>
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-text-field
                label="Número de factura"
                type="text"
                v-model="screen_data.new_effect.invoice_number"
                :hideDetails="true"
              >
              </app-text-field>
            </app-col>
          </app-row>  
          <app-row contains-input-fields>
            <app-col contains-input-fields cols="12">
              <app-date-picker
                aucomplete="off"
                label="Fecha"
                v-model="screen_data.new_effect.date"                
              ></app-date-picker>
            </app-col>
          </app-row>            
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <app-btn outlined @click="screen_data.dialog_create_effect_manual=false">Cancelar</app-btn>
          <app-btn
            class="mr-3" 
            color="primary" 
            @click="addEffect()" 
            :loading="screen_data.loadingCreateEffect"
            :disabled="!screen_data.new_effect.concept || !screen_data.new_effect.amount || !screen_data.new_effect.date || !screen_data.new_effect.account || !screen_data.new_effect.effect_type || !screen_data.new_effect.invoice_number"
          >
            Crear
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-card class="effects-list-card">
      <v-card-title> 
        <div class="effects-list-title mr-auto">Efectos</div>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">                
              <v-btn 
                @click="screen_data.dialog_configuration = true"
                v-bind="attrs"
                v-on="on"
                color="primary"
                icon 
                >
                <v-icon>mdi-cog-outline</v-icon>                  
              </v-btn>
            </template>
            <span>Configuracion</span>
          </v-tooltip>

          <JobProgress v-if="currentCompany" v-model="screen_data.importEffectsJobState" v-on:done="importEffectsJobDone(true)" v-on:error="importEffectsJobError()" :job_id="screen_data.importEffectsJobId" class="progress_circular">
            <template v-slot:progress>
                <v-progress-circular
                    v-if="screen_data.importEffectsJobState==='running'"
                    indeterminate           
                    color="primary"
                    class="progress_circle"
                ></v-progress-circular>
            </template>
            <template v-slot:done>
              <v-tooltip top v-if="screen_data.effectsOriginConfig && screen_data.effectsOriginConfig == 'inmatic'">
                <template v-slot:activator="{ on, attrs }">                
                  <v-btn 
                    @click="dialog_import_effects = true"
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    :loading="screen_data.loadingImportEffects"
                    icon 
                    >
                    <v-icon>mdi-archive-sync</v-icon>                  
                  </v-btn>
                </template>
                <span>Sincronizar efectos Inmatic</span>
              </v-tooltip>
              
              <v-tooltip top v-if="screen_data.effectsOriginConfig && screen_data.effectsOriginConfig == 'excel'">
                <template v-slot:activator="{ on, attrs }">                
                  <v-btn 
                    @click="screen_data.dialog_upload_excel=true;"
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    :loading="screen_data.loadingUploadEffects"
                    icon 
                    >
                    <v-icon class="material-symbols-outlined">upload_file</v-icon>                 
                  </v-btn>
                </template>
                <span>Cargar Efectos desde Excel</span>
              </v-tooltip>
            </template>
          </JobProgress>

          <v-tooltip top v-if="screen_data.effectsOriginConfig && screen_data.effectsOriginConfig == 'accounting_program'">
            <template v-slot:activator="{ on, attrs }">                
              <v-btn 
                @click="dialog_import_effects_accounting_program = true"
                v-bind="attrs"
                v-on="on"
                color="primary"
                :loading="screen_data.loadingImportEffectsAccountingProgram"
                icon 
                >
                <v-icon>mdi-monitor-arrow-down</v-icon>                  
              </v-btn>
            </template>
            <span>Importar efectos del programa contable</span>
          </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-0">
        <v-row>
          <app-search-bar
            :filters="listFilters"
            @updateObject="updateFilter"
            @resetAllFilters="removeAllFilt"
            :pin-state="true"
          />
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <div align="right">
              <v-tooltip top v-if="permission.can_write">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      color="primary" 
                      icon 
                      v-bind="attrs" 
                      v-on="on"
                      :disabled="!(screen_data.selectedEffects.length > 0)"
                      @click="validateAndShowMarkPopup();"
                    >
                      <v-icon>mdi-check-circle-outline</v-icon>
                    </v-btn>
                </template>
                <span> Puntear efectos manualmente </span>
              </v-tooltip>
              <v-tooltip top v-if="permission.can_write">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      color="primary" 
                      icon 
                      v-bind="attrs" 
                      v-on="on"
                      :disabled="!(screen_data.selectedEffects.length > 0)"
                      @click="validateAndShowUnmarkPopup();"
                    >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                </template>
                <span> Despuntear efectos </span>
              </v-tooltip>
              <v-tooltip top v-if="permission.can_write">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    @click="screen_data.dialog_create_effect_manual = true"
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    icon 
                    >
                    <v-icon>mdi-plus-circle-outline</v-icon>                  
                  </v-btn>
                </template>
                <span>Añadir efecto manual</span>
              </v-tooltip>
              <v-tooltip top v-if="permission.can_write">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      color="primary" 
                      icon 
                      v-bind="attrs" 
                      v-on="on"
                      :disabled="!(screen_data.selectedEffects.length > 0)"
                      @click="showDeleteEffectsPopup = true;"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>
                <span> Eliminar efectos </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">                
                  <v-btn 
                    @click="refresh_data()"
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    icon 
                    >
                    <v-icon> mdi-refresh</v-icon>                  
                  </v-btn>
                </template>
                <span>Actualizar</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="permission.can_write">
          <v-col class="py-0">
            <v-data-table
              class="effects-table"
              :items="screen_data.effects"
              :headers="effects_headers"
              fixed-header
              :show-select="screen_data.showSelectEffects"
              v-model="screen_data.selectedEffects"
              :loading="screen_data.loading"        
              item-key="id"
              :footer-props="{
                'items-per-page-options': [5, 10, 50, 100],
                'items-per-page-text': 'Efectos por página:',
              }"
            >
              <template v-for="header in effects_headers" v-slot:[`item.${header.value}`]="{ item }">
                <span class="font-color" :key="header.value">
                  <slot v-if="header.value == 'state'" :name="header.value" v-bind="item">
                    <v-tooltip top v-if="item[header.value] == 'no_punteado'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-circle-outline</v-icon>
                      </template>
                      <span>No punteado</span>
                    </v-tooltip>
                    <v-tooltip top v-else-if="item[header.value] == 'punteado_parcial'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="#yellow" v-bind="attrs" v-on="on">mdi-circle-half-full</v-icon>
                      </template>
                      <span>Punteado parcialmente</span>
                    </v-tooltip>
                    <v-tooltip top v-else-if="item[header.value] == 'punteado_manualmente'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="blue" v-bind="attrs" v-on="on">mdi-circle</v-icon>
                      </template>
                      <span>Punteado manualmente</span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="var(--v-success-base)" v-bind="attrs" v-on="on">mdi-circle</v-icon>
                      </template>
                      <span>Punteado</span>
                    </v-tooltip>
                  </slot>
                  <slot v-else-if="header.value == 'effect_type'" :name="header.value" v-bind="item">
                    <span v-if="item[header.value] == 'receivable_effect'">Cobro</span>
                    <span v-else>Pago</span>
                  </slot>
                  <slot v-else-if="header.value == 'date'" :name="header.value" v-bind="item">
                    <span>{{ changeFormat(item[header.value]) }}</span>                      
                  </slot>
                  <slot v-else-if="header.value == 'origin'" :name="header.value" v-bind="item">
                    <span>{{ originTranslator(item[header.value]) }}</span>
                  </slot>
                  <slot v-else :name="header.value" v-bind="item">
                    {{ item[header.value] }}
                  </slot>
                </span>
              </template>
          
            </v-data-table>
          </v-col>
        </v-row>
        <div class="effects-total-amount"><span>Importe:</span> {{ totalAmountEffects }}</div>  
      </v-card-text>
    </v-card>

    <app-confirm-modal
      v-model="showDeleteEffectsPopup"
      text-msg="Se van a borrar los Efectos seleccionados."
      :loading="loadingDeleteEffects"
      @confirm="deleteEffects()"
      @cancel="showDeleteEffectsPopup = false"
    >
    </app-confirm-modal>

    <app-confirm-modal
      v-model="showMarkAsManuallyCheckedPopup"
      text-msg="Se van a marcar los Efectos seleccionados como punteados manualmente."
      :loading="loadingMarkAsManuallyChecked"
      @confirm="markEffectsAsManuallyChecked()"
      @cancel="showMarkAsManuallyCheckedPopup = false"
    >
    </app-confirm-modal>

    <app-confirm-modal
      v-model="showUnmarkAsManuallyCheckedPopup"
      text-msg="Se van a despuntear los Efectos seleccionados, volviendo al estado 'No punteado'."
      :loading="loadingUnmarkAsManuallyChecked"
      @confirm="unmarkEffectsAsManuallyChecked()"
      @cancel="showUnmarkAsManuallyCheckedPopup = false"
    >
    </app-confirm-modal>

    <v-snackbar
      v-model="screen_data.snackbar.isVisible"
      :color="screen_data.snackbar.color"
      :timeout="screen_data.snackbar.timeout"
    >
      {{ screen_data.snackbar.text }}
    </v-snackbar> 
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { VueEffectListScreenData } from '@/modules/effects/infra/VueEffectListScreenData';
import { ApiEffectRepository } from '@/modules/effects/infra/ApiEffectRepository';
import { EffectsComponent } from '../modules/effects/app/EffectsComponent';
import { ApiJobRepository } from '@/modules/jobs/infra/ApiJobRepository';
import JobProgress from '@/components/JobProgress.vue';
import AppDatePicker from '@/components/layout/AppDatePicker.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppDocTextField from "@/components/layout/AppDocTextField.vue";
import AppSelect from '@/components/layout/AppSelect.vue';
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue'
import { S3Repository } from '@/modules/shared/infra/S3Repository';
import awsconfig from '../aws-exports';

export default {
  name: 'BankEffectsTable',  
  components: {
    JobProgress,
    AppDatePicker,
    AppSearchBar,
    AppConfirmModal,
    AppBtn,
    AppRow,
    AppCol,
    AppTextField,
    AppSelect,
    AppDocTextField
  
    },
  computed: {
    ...mapState(['currentCompany']),
    ...mapState(['session_information']),  
    ...mapGetters({
      userData: 'me/userData',            
      permission: 'permissions/permission',
      got_feature:'got_feature',      
    }),
    ...mapGetters('effects', ['listFilters']),
    totalAmountEffects() {
      let total = 0
      if (this.screen_data.selectedEffects.length > 0) {
        for (let f in this.screen_data.selectedEffects) {
          total+=this.screen_data.selectedEffects[f].amount;
        }
      }
      else {
        for (let f in this.screen_data.effects) {
          total+=this.screen_data.effects[f].amount;
        }
      }
      return Number(total.toFixed(2));
    },
    company_id() {
      return this.currentCompany.id
    }    
  },  
  
  data() {
    const screen_data = new VueEffectListScreenData();
    return {            
      screen_data: screen_data,
      effects_component: null,      
      effects_headers: [
        {
          text: 'Estado',
          sortable: false,
          value: 'state',
          width:1,
        },
        {
          text: 'Fecha',
          sortable: false,
          value: 'date'
        },
        {
          text: 'Importe',
          sortable: false,
          value: 'amount'
        },           
        {
          text: 'Importe no punteado',
          sortable: false,
          value: 'amount_no_punteado'
        },  
        {
          text: 'Cuenta',
          sortable: false,
          value: 'account'
        },           
        {
          text: 'Concepto',
          sortable: false,
          value: 'concept'
        },        
        {
          text: 'Tipo de efecto',
          sortable: false,
          value: 'effect_type'
        },
        {
          text: 'Num. Factura',
          sortable: false,
          value: 'invoice_number'
        },
        {
          text: 'Fec. Vencimiento',
          sortable: false,
          value: 'due_date'
        },   
        {
          text: 'Origen',
          sortable: false,
          value: 'origin'
        }, 
      ],            
      showSelectEffects: false,
      showDeleteEffectsPopup:false,
      loadingDeleteEffects:false,
      showMarkAsManuallyCheckedPopup:false,
      loadingMarkAsManuallyChecked:false,
      showUnmarkAsManuallyCheckedPopup:false,
      loadingUnmarkAsManuallyChecked:false,
      dialog_import_effects: false,
      import_effects_min_date: undefined,
      import_effects_max_date: undefined,
      isValidFormImportEffects: false, 
      dialog_import_effects_accounting_program: false,
      import_effects_accounting_program_min_date: undefined,
      import_effects_accounting_program_max_date: undefined,
      isValidFormImportEffectsAccountingProgram:false,
      creds: undefined,
      effects_type: [
        {text: "Pago", value: "payable_effect"},
        {text: "Cobro", value: "receivable_effect"}
      ]
    }
  },

  async mounted() {
    this.creds = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
    });
    this.creds.params.Logins = this.creds.params.Logins || {};
    this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] =  this.session_information.signInUserSession.idToken.jwtToken;
    this.creds.expired = true;
    AWS.config.update({
        region: awsconfig['aws_user_files_s3_bucket_region'],
        credentials: this.creds,
    });    

    let effects_repo = new ApiEffectRepository()        
    let effects = await effects_repo.filter_by_company_id(this.currentCompany.id)
    this.screen_data.setEffects(effects)
    if (effects.length > 0) {
      this.screen_data.setShowSelectEffects(true);
    }
    let jobs_repo = new ApiJobRepository()  
    this.effects_component = new EffectsComponent(effects_repo, jobs_repo, this.screen_data,  new S3Repository(AWS,'excel_eff'))

    this.effects_component.get_effects_configuration(this.currentCompany.id)
  },

  async created() {   
  },
  methods: {
    ...mapActions("effects", ['updateObject','removeAllFilters']),    
    async refresh_data() {
      this.effects_component.get_effects(this.currentCompany.id, this.listFilters);
    },

    async importEffects() {
      this.effects_component.import_effects(this.currentCompany.id, this.import_effects_min_date, this.import_effects_max_date);
      this.dialog_import_effects = false;
    },

    async importEffectsJobDone() {
      this.effects_component.import_effects_done(this.currentCompany.id, false);
    },

    async importEffectsJobError() {
      this.effects_component.import_effects_done(this.currentCompany.id, true);
    },

    async importEffectsAccountingProgram() {
      this.effects_component.import_effects_accounting_program(this.currentCompany.id, this.import_effects_accounting_program_min_date, this.import_effects_accounting_program_max_date);
      this.dialog_import_effects_accounting_program = false;
    },

    async updateFilter(params){
      console.log(params)
      this.updateObject(params)
      console.log(this.listFilters)
      this.effects_component.get_effects(this.currentCompany.id, this.listFilters)
    },
    async removeAllFilt(p){
      this.removeAllFilters()
      this.effects_component.get_effects(this.currentCompany.id, this.listFilters)      
    },
    async deleteEffects() {
      let selected_ids = this.getSelectedTransactions();
      try {
        this.loadingDeleteEffects = true;
        this.effects_component.delete_effects(selected_ids, this.currentCompany.id, this.listFilters);        
        this.showDeleteEffectsPopup = false;
        this.loadingDeleteEffects = false;
      } catch(error) {
        console.error('Error delete effects:', error);
        this.showDeleteEffectsPupup = false;
        this.loadingDeleteEffects = false;
        //this.show_error_message = true;
      }
    },
    validateAndShowMarkPopup() {
      // Validar que todos los efectos seleccionados sean no_punteado
      const invalidEffects = this.screen_data.selectedEffects.filter(effect => effect.state !== 'no_punteado');
      
      if (invalidEffects.length > 0) {
        // Mostrar mensaje de error
        this.screen_data.error_message('Solo se pueden puntear manualmente efectos que estén en estado "No punteado". Algunos de los efectos seleccionados ya están punteados.');
        return;
      }
      
      // Si todos son válidos, mostrar el modal de confirmación
      this.showMarkAsManuallyCheckedPopup = true;
    },
    async markEffectsAsManuallyChecked() {
      let selected_ids = this.getSelectedTransactions();
      try {
        this.loadingMarkAsManuallyChecked = true;
        await this.effects_component.mark_effects_as_manually_checked(selected_ids, this.currentCompany.id, this.listFilters);
        this.showMarkAsManuallyCheckedPopup = false;
        this.loadingMarkAsManuallyChecked = false;
        this.screen_data.selectedEffects = [];
      } catch(error) {
        console.error('Error marking effects as manually checked:', error);
        this.showMarkAsManuallyCheckedPopup = false;
        this.loadingMarkAsManuallyChecked = false;
      }
    },
    validateAndShowUnmarkPopup() {
      // Validar que todos los efectos seleccionados sean punteados manualmente
      const invalidEffects = this.screen_data.selectedEffects.filter(effect => effect.state !== 'punteado_manualmente');
      
      if (invalidEffects.length > 0) {
        // Mostrar mensaje de error
        this.screen_data.error_message('Solo se pueden despuntear efectos que han sido punteados manualmente. Algunos de los efectos seleccionados no cumplen esta condición.');
        return;
      }
      
      // Si todos son válidos, mostrar el modal de confirmación
      this.showUnmarkAsManuallyCheckedPopup = true;
    },
    async unmarkEffectsAsManuallyChecked() {
      let selected_ids = this.getSelectedTransactions();
      try {
        this.loadingUnmarkAsManuallyChecked = true;
        await this.effects_component.unmark_effects_as_manually_checked(selected_ids, this.currentCompany.id, this.listFilters);
        this.showUnmarkAsManuallyCheckedPopup = false;
        this.loadingUnmarkAsManuallyChecked = false;
        this.screen_data.selectedEffects = [];
      } catch(error) {
        console.error('Error unmarking effects as manually checked:', error);
        this.showUnmarkAsManuallyCheckedPopup = false;
        this.loadingUnmarkAsManuallyChecked = false;
      }
    },
    getSelectedTransactions(){
      let selected_ids = []
      for(let i in this.screen_data.selectedEffects){
        selected_ids.push(this.screen_data.selectedEffects[i].id)
      }
      return selected_ids
    },
    uploadExcelEffects() {
      this.effects_component.upload_effects(this.currentCompany.id, this.screen_data.file)
    },
    updateEffectsConfiguration() {
      this.effects_component.update_effects_configuration(this.currentCompany.id, this.screen_data.effectsOriginConfig, this.screen_data.automaticEffectsInmaticConfig)
      this.screen_data.dialog_configuration = false;
    },
    changeFormat(dateString){
      const dateObject = new Date(dateString);
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, '0');
      const day = String(dateObject.getDate()).padStart(2, '0');
      return `${day}/${month}/${year}`;
    },
    addEffect(){
      this.effects_component.add_effect_manual(this.currentCompany.id, this.screen_data.new_effect, this.listFilters)
      this.screen_data.dialog_create_effect_manual = false;
    },
    originTranslator(state) {
      const fieldMap = {
          'accounting_program_effect': 'Programa contable',
          'inmatic': 'Inmatic',
          'inmatic_automatic': 'Inmatic automático',
          'excel_effect': 'Excel',
          'manual': 'Manual',
          'api': 'API'
      };

      return fieldMap[state] || state;
    },
  },
  watch: {
    company_id(val, oldVal) {                
      this.refresh_data();
    }
  }
}
</script> 

<style scoped> 
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .effects-table >>> tbody td {
    font-size:12px !important;
    height: 40px !important;
  } 
  .effects-table >>> tbody td .v-icon {
    font-size: 20px !important;
  }
  .effects-table >>> thead th {
    background-color: var(--v-primaryLight-base) !important;
    color:var(--v-primary-base) !important;
  }
  .effects-list-card {
    border-radius: 10px;
  }

  .effects-total-amount {
    position:absolute;
    bottom:30px;
    font-size: 12px;
  }
  .effects-total-amount span {
    color:var(--v-primary-base);
    font-weight: bold;
  }
  
</style>